
angular.module("app").directive("okinaPopupDetailStopArea",[
	"$uibModal", "$filter", "$compile", "$location", "$window","toastr", "SecurityService", "TableSortingService", "Utils", "CartoService", "ExploitationService",
	function ($uibModal, $filter, $compile, $location, $window,toastr, SecurityService, TableSortingService, Utils, CartoService, ExploitationService) {

	return {
		restrict: "E",
		replace: true,
		templateUrl: "common/directives/exploitation/okinaPopupDetailStopArea/okinaPopupDetailStopArea.html",
		scope: {
			stopPoint: "=",
			callback: "=",
		},
		link: function(scope) {
			scope.checkAccess = SecurityService.checkAccess;

			if (!scope.stopPoint.liaisons || !scope.stopPoint.liaisons[0]) {
				scope.currentOrder = "id";
				scope.ORDER_FIELDS = {
					ID: 'id',
					LASTNAME: 'lastName',
					FIRSTNAME: 'firstName',
					ETABLISSEMENT: 'establishement',
					SCHOOL_CLASS: 'schoolClass',
					ADDRESS: 'address',
					ADDRESS2: 'secondeResidance',
					STATUS: 'status'
				};
				getInfosAndLaisonStopPoint();
			}

			/**
			 * Récupérer les liaisons pour un stop area
			 */
			function getInfosAndLaisonStopPoint() {
				ExploitationService.getNetworkLinesInfoForStopPoint(scope.stopPoint.id).then((response) => {
					const data = response.data;
					scope.stopPoint = data[0];

					if (scope.stopPoint.liaisons) {
						scope.stopPoint.liaisons.forEach(liaison => {
							if (liaison.lignes) {
								liaison.lignes.forEach(ligne => {
									ligne.isOpen = false;
								});
							}
						});
					}

					scope.stopPoint.htmlColorUsage = CartoService.getStopAreaUsageColorPopupHtml(scope.stopPoint.colorUsage);
					scope.callback !== undefined && typeof(scope.callback) === "function" ? scope.callback(scope.stopPoint) : null;
				}).catch(() => toastr.warning("Impossible de charger les liaisons pour cet arrêt"));
			}

			/**
			 * Récupérer les routes pour chacune des liaisons
			 */
			scope.getRoutesForThisLine = (event, lineId) => {
				//Permet le control sur l'input 'is-open' des groupes de lignes et le control du sens de la fléche.
				//Dans un premier temps déplit la list
				//Repli la list si déja ouverte
				scope.currentLineIdForArrowSensAndIsOpenControl = scope.turnRightArrowIfSameLineToggledUp(lineId);

				//Ne requete pas lorsque repli un list group
				if (!scope.currentLineIdForArrowSensAndIsOpenControl) return;

				//Destruction avant chargement asynchrone pour parer aux problémes d'entropie sur affichage des données.
				scope.routes = null;
				ExploitationService.getRoutes(lineId, false).then((response) => {
					const routesData = response.data;

					if (routesData) {
						routesData.forEach(route => {
							route.isOpen = false;
						});
					}
					scope.routes = routesData;
				});
			};

			/*
			Redirect to Vehicle Journeys
			 */
			scope.goToVehicleJourneys = function(event, routeId){
				$location.path("/e-iti/courses/"+routeId);
			};

			/**
			 * Récupérer les courses pour chacunes des routes
			 * @param routeId
			 */
			scope.getCoursesForThisRoute = function(event, route) {
				//Evite la propagation du clique sur le parent,evite ainsi la fermeture inopiné de la list.
				event.stopPropagation();

				if (route.isOpen) {
					// On affiche "Chargement..."
					scope.courses = null;

					let params = {
						"route": route.id,
						"page": 1,
						"pageSize": 10,
						"paginated": true
					};

					ExploitationService.getVehicleJourneysForJourneyPattern(params).then(response => {
						scope.courses = response.data;
					});
				}
			};


			/**
			 * Récupérer les abonnées
			 * @param lineId
			 * @param stopAreaId
			 */
			scope.getSubscriptionsOnStopPointForGivenVehicleJourney = (event, line, route, vehicleJourney, stopAreaId) => {
				event.stopPropagation();
				ExploitationService.getListSubscriberOnCourseUsingStopArea(vehicleJourney.id, stopAreaId).then(response => {
					const data = response.data;
					if(data.length === 0) {
						Utils.openModal($uibModal, "noSubscriberInStopPoint.html", scope, "lg");
					} else {
						scope.subscribersStopPoint = data;
						scope.current = {
							line: line,
							route: route,
							vehicleJourney: vehicleJourney
						};
						Utils.openModal($uibModal, "subscriberInStopPoint.html", scope, "lg");
					}

				}).catch(() => toastr.warning("Impossible de récupérer les abonnés de cette ligne"));
			};

			/**
			 * Alimente la ligne courante dans le modéle
			 */
			scope.getArrowSens = (lineId) => {
				return scope.currentLineIdForArrowSensAndIsOpenControl === lineId;
			};

			/**
			 * Alimente conditionnellement currentLineIdForArrowSensAndIsOpenControl
			 * Si l'utilisateur ouvre et referme une meme ligne alors la fleche change en conséquence
			 * @param lineId
			 * @returns {*}
			 */
			scope.turnRightArrowIfSameLineToggledUp = (lineId) => {
				return scope.currentLineIdForArrowSensAndIsOpenControl !== lineId ? lineId : null;
			}

			/**
			 * Alimente conditionnellement currentRouteIdForIsOpenControl
			 * Si l'utilisateur ouvre et referme une meme route la list groupe se referme
			 * @param lineId
			 * @returns {*}
			 */
			scope.IfSameRouteToggledUp = (routeId) => {
				return scope.currentRouteIdForIsOpenControl !== routeId ? routeId : null;
			}

			/**
			 * Modifie l'order.
			 * Si déja selectionné, inverse le sens, sinon applique le nouveau dans le sens +
			 * @param order
			 */
			scope.changeOrder = (order) => {
				scope.currentOrder = TableSortingService.changeOrder(scope.currentOrder, order);
				scope.subscribersStopPoint = $filter('orderBy')(scope.subscribersStopPoint, scope.currentOrder);
			};

			/**
			 * Retourne le template de l'icone de fleche a afficher
			 * @param order
			 * @returns {string}
			 */
			scope.getArrowIconForOrder = (order) => {
				if(!scope.currentOrder) return;
				return TableSortingService.getArrowIconForOrder(scope.currentOrder, order);
			};

			/**
			 * Go to edit stop page
			 */
			scope.goToEditStopPage = (stopId) => {
				$window.open("#/e-iti/arrets/"+stopId);
			}
		}
	}

}]);